import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectorRef
} from "@angular/core";
import { Globals } from "@foh/globals";
import { ActivatedRoute, Router } from "@angular/router";
import { TicketpaymentService } from "./ticketpayment.service";
import * as alertFunctions from "@foh/shared/data/sweet-alerts";
import * as utils from "@foh/shared/services/utils";
import { NgForm, NgModel } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-ticket-payment",
  templateUrl: "./ticket-payment.component.html",
  styleUrls: ["./ticket-payment.component.scss"]
})
export class TicketPaymentComponent implements OnInit {
  imageSrc: string;
  currentStep: string;
  invalidUrlMsg: string;
  record: any;
  billing: any;
  list: any;
  paidTickets: any;
  venue: any;
  ticketsCats: any;
  token: any;
  reservation: any;
  group: any;
  eventName: any;
  ticketGroupCode: any;
  orderId: any;
  routeObs$: any;
  selectedTickets: any;
  totalTickets: any;
  totalPrice: any;
  loading: boolean = false;
  isHold: boolean = false;
  isPaid: boolean = false;
  invalidUrlError: boolean = false;
  loadingPaymentFrame: boolean = true;
  errorPaymentFrame: boolean = false;
  paymentIframeSrc: SafeResourceUrl;
  extraFees: number = 0;
  formattedBranch: any;
  formattedSlot: any;
  formattedDate: any;
  @ViewChild("billingfname") billingFName: NgModel;
  @ViewChild("billinglname") billingLName: NgModel;
  @ViewChild("billingmobileno") billingMobileno: NgModel;
  @ViewChild("billingemail") billingEmail: NgModel;
  @ViewChild("billingstreet") billingStreet: NgModel;
  @ViewChild("billingcountry") billingCountry: NgModel;
  @ViewChild("billingcity") billingCity: NgModel;
  constructor(
    private activeRoute: ActivatedRoute,
    private globals: Globals,
    private cDR: ChangeDetectorRef,
    public sanitizer: DomSanitizer,
    public router: Router,
    private ticketpaymentService: TicketpaymentService
  ) {
    //fc64mukl
    this.list = [];
    this.paidTickets = [];
    this.selectedTickets = 0;
    this.totalTickets = 0;
    this.totalPrice = 0;
    this.billing = {
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      street: "",
      country: "",
      city: ""
    };
  }

  ngOnInit() {
    this.currentStep = "1";
    this.routeObs$ = this.activeRoute.params.subscribe(params => {
      this.token = params["token"];
      this.ticketGroupCode = params["ticketid"];
      this.orderId = params["orderid"];

      if (
        this.token != "" &&
        this.ticketGroupCode != "" &&
        this.orderId != "" &&
        typeof this.orderId !== "undefined"
      ) {
        this.setupPaymentOrderRetrieve(params);
      }
      if (
        this.token != "" &&
        this.ticketGroupCode != "" &&
        (this.orderId == null ||
          this.orderId == "" ||
          typeof this.orderId === "undefined")
      ) {
        this.setupInitPayment(params);
      }
    });
  }

  setupPaymentOrderRetrieve(params) {
    this.loading = true;
    this.ticketpaymentService.retrieveOrderStatus(params).subscribe(
      (response: any) => {
        //continue here
        this.loading = false;
        if (response.recordStatus == true) {
          this.paidTickets = response.paidTickets;
          this.ticketsCats = response.ticketCats;
          this.injectTicketCatsToPaidTickets();
          this.showStep4();
        }
      },
      error => {
        this.loading = false;
      }
    );
  }

  setupInitPayment(params) {
    this.loading = true;
    this.ticketpaymentService.getTicketGroup(params).subscribe(
      (response: any) => {
        this.loading = false;
        this.list = [];
        this.venue = response.venue;
        this.reservation = response.reservation;
        this.imageSrc = this.globals.UPLOADS + "logos/" + response.metaData.logo;
        var unFormattedDate = utils.formatDateSqlToCustomObject(this.reservation.date);
        this.formattedDate = utils.formatDateCustomObjectToSql(unFormattedDate);
        this.formattedBranch = this.reservation.branch.name;
        this.group = response.group;
        this.eventName = response.eventName;
        this.extraFees = response.flatFees;
        // this.ticketsCats = response.ticketsCats;
        // this.injectTicketCats();
        this.totalTickets = this.list.length;
        this.totalPrice = this.group.amount + this.extraFees;
        // this.updateSelectedTicketsNumber();
        if (response.paid == true) {
          this.isPaid = response.paid;
          this.paidTickets = response.list;
          this.ticketsCats = response.ticketCats;
          this.injectTicketCatsToPaidTickets();
          this.showStep4();
          return;
        }
        if (this.group.ishold) {
          this.isHold = this.group.ishold;
          this.showStep4();
          return;
        }
        this.showStep1();
      },
      (error: any) => {
        this.loading = false;
        this.invalidUrlError = true;
        this.invalidUrlMsg = error.error.message;
      }
    );
  }

  showStep1() {
    this.currentStep = "1";
  }

  showStep2() {
    this.currentStep = "2";
  }

  showStep3() {
    this.currentStep = "3";
  }

  showStep4() {
    this.currentStep = "4";
  }

  validateStep1(event, currentIndex, newIndex) {
    if (this.totalPrice <= 0) {
      return false;
    }
    return true;
  }
  validateStep2() {
    return (
      this.billingFName.valid &&
      this.billingLName.valid &&
      this.billingMobileno.valid &&
      this.billingEmail.valid &&
      this.billingStreet.valid &&
      this.billingCountry.valid &&
      this.billingCity.valid
    );
  }

  createPaymentLink() {
    if (!this.validateStep2()) {
      return;
    }
    this.showStep3();
    this.getPaymentLink();
  }

  getPaymentLink() {
    this.ticketpaymentService
      .createPaymentLink({
        token: this.token,
        ticketid: this.ticketGroupCode,
        ticketsids: this.getSelectedTicketsId(),
        billing: this.billing
      })
      .subscribe(
        (response: any) => {
          this.paymentIframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
            response
          );
          this.loadingPaymentFrame = false;
        },
        error => {
          this.loadingPaymentFrame = false;
          this.errorPaymentFrame = true;
        }
      );
  }

  injectTicketCats() {
    for (var i = 0; i < this.list.length; i++) {
      var ticketCat = this.getTicketCatById(this.list[i].ticketcat_id);
      this.list[i].ticketName = ticketCat.name;
      this.list[i].ticketPrice = ticketCat.price;
      this.list[i].selected = true;
    }
  }

  getTicketCatById(id) {
    for (var i = 0; i < this.ticketsCats.length; i++) {
      if (this.ticketsCats[i].id == id) {
        return this.ticketsCats[i];
      }
    }
    return null;
  }

  updateSelectedTicketsNumber() {
    var counter = 0;
    var total = 0;
    for (var i = 0; i < this.list.length; i++) {
      if (this.list[i].selected) {
        counter++;
        total += this.list[i].ticketPrice;
      }
    }
    this.selectedTickets = counter;
    this.totalPrice = total;
  }

  getSelectedTicketsId() {
    var ids = [];
    for (var i = 0; i < this.list.length; i++) {
      if (this.list[i].selected) {
        ids.push(this.list[i].id);
      }
    }
    return ids;
  }

  injectTicketCatsToPaidTickets() {
    for (var i = 0; i < this.paidTickets.length; i++) {
      var ticketCat = this.getTicketCatById(this.paidTickets[i].ticketcat_id);
      this.paidTickets[i].ticketName = ticketCat.name;
      this.paidTickets[i].ticketPrice = ticketCat.price;
    }
  }

  changePaymentMethod() {
    this.loading = true;
    this.ticketpaymentService
      .deleteTicketsGroup({ token: this.token })
      .subscribe(
        (response: any) => {
          this.loading = false;
          this.router.navigate(["manage-creditcards/" + this.token]);
        },
        error => {
          this.loading = false;
        }
      );
  }
}
